import m, { useRef as S, useEffect as f, useCallback as p, useState as O } from "react";
import { g as w, a as A, i as M } from "./isClient-ec947a14.mjs";
const j = (s, t, e = A ? window : void 0, l = {}) => {
  const r = S(t);
  f(() => {
    r.current = t;
  }, [t]), f(() => {
    const o = w(e);
    if (!r.current || !(o != null && o.addEventListener))
      return;
    const c = (n) => {
      var a;
      return (a = r.current) == null ? void 0 : a.call(r, n);
    };
    return o.addEventListener(s, c, l), () => {
      o.removeEventListener(s, c, l);
    };
  }, [s, e, l]);
};
function y() {
  const s = S(!1);
  return f(() => (s.current = !0, () => {
    s.current = !1;
  }), []), p(() => s.current, []);
}
const z = (s = A ? window.document.body : void 0, t) => {
  const [e, l] = O({}), r = y(), o = S(t), c = S(A && M("ResizeObserver"));
  return f(() => {
    o.current = t;
  }, [t]), f(() => {
    if (!c.current)
      return;
    const n = w(s);
    if (!n)
      return;
    const a = (d, g) => {
      window.requestAnimationFrame(() => {
        var b;
        l(d[0]), (b = o.current) == null || b.call(o, d, g);
      });
    }, i = new ResizeObserver(a);
    return i.observe(n), a([{ target: n }], i), () => i.disconnect();
  }, [s, r]), e;
}, X = {
  target: {},
  isOverFlown: !1,
  isOverFlownX: !1,
  isOverFlownY: !1
}, T = (s) => {
  const t = w(s);
  if (!t)
    return X;
  const e = t.clientWidth < t.scrollWidth, l = t.clientHeight < t.scrollHeight;
  return {
    target: t,
    isOverFlown: e || l,
    isOverFlownX: e,
    isOverFlownY: l
  };
}, C = (s, t) => {
  const e = S(t);
  f(() => {
    e.current = t;
  }, [t]);
  const l = z(s, (r) => {
    var o, c;
    (c = e.current) == null || c.call(e, T((o = r == null ? void 0 : r[0]) == null ? void 0 : o.target));
  });
  return T(l.target);
}, Y = {
  isScrollable: !1,
  isScrollableX: !1,
  isScrollableY: !1,
  isScrollAtStart: !0,
  isScrollXAtStart: !0,
  isScrollYAtStart: !0,
  isScrollAtEnd: !1,
  isScrollXAtEnd: !1,
  isScrollYAtEnd: !1,
  ...X
}, h = (s) => {
  const t = w(s.target);
  if (!t)
    return Y;
  const { scrollLeft: e, scrollTop: l, scrollWidth: r, scrollHeight: o, clientWidth: c, clientHeight: n } = t, a = s.isOverFlownX, i = s.isOverFlownY, d = a || i, g = a && Math.ceil(e + c) >= Math.ceil(r), b = i && Math.ceil(l + n) >= Math.ceil(o), E = a && e === 0, v = i && l === 0;
  return {
    isScrollable: d,
    isScrollableX: a,
    isScrollableY: i,
    isScrollAtEnd: g || b,
    isScrollAtStart: E || v,
    isScrollXAtEnd: g,
    isScrollYAtEnd: b,
    isScrollXAtStart: E,
    isScrollYAtStart: v,
    scrollLeft: e,
    scrollTop: l,
    scrollWidth: r,
    scrollHeight: o,
    clientWidth: c,
    clientHeight: n,
    scrollTo: (u) => t.scrollTo(u),
    scrollToTop: (u) => t.scrollTo({ ...u, top: 0 }),
    scrollToBottom: (u) => t.scrollTo({ ...u, top: o }),
    scrollToLeft: (u) => t.scrollTo({ ...u, left: 0 }),
    scrollToRight: (u) => t.scrollTo({ ...u, left: r })
  };
}, k = (s, t) => {
  const [e, l] = O(Y), r = S(t);
  return f(() => {
    r.current = t;
  }, [t]), C(s, (o) => {
    var n;
    const c = { ...e, ...o, ...h({ ...e, ...o }) };
    l(c), (n = r.current) == null || n.call(r, c);
  }), j(
    "scroll",
    (o) => {
      var n;
      const c = {
        ...e,
        target: o.target,
        ...h({ ...e, target: o.target })
      };
      l(c), (n = r.current) == null || n.call(r, c);
    },
    s
  ), e;
};
var R = /* @__PURE__ */ ((s) => (s.ALL = "all", s.LAST = "last", s.FIRST = "first", s))(R || {});
const F = (s, t, e = "all") => {
  const l = { rest: [] };
  return Object.keys(t).forEach((r) => {
    l[r] = [];
  }), m.Children.forEach(s, (r) => {
    if (!m.isValidElement(r))
      return r && l.rest.push(r);
    const o = Object.keys(t).find((c) => {
      const n = t[c];
      return Array.isArray(n) ? n.some((a) => r.type === a) : r.type === n;
    });
    (o ? l[o] : l.rest).push(r);
  }), Object.fromEntries(
    Object.entries(l).map(([r, o]) => [
      r,
      r !== "rest" && e !== "all" ? e === "first" ? o.at(0) : o.at(-1) : o
    ])
  );
}, H = (s, t = {}, e = "all") => {
  const l = S(t), [r, o] = O(F(s, t, e));
  return f(() => {
    o(F(s, l.current, e));
  }, [s, e]), r;
};
H.PickType = R;
export {
  R as U,
  z as a,
  H as b,
  y as c,
  C as d,
  k as e,
  F as f,
  X as o,
  j as u
};
